module.exports = __webpack_public_path__ + "img/744.fb0861e2.jpg";